import React, { useEffect,useState } from 'react';
import api from "../../../common/api";
import CircularProgress from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/styles/makeStyles';
import {MaterialTable} from '../../../components';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PPMobileCardView from '../../../components/PPMobileCardView';

const useStyles = makeStyles(theme => ({
    progressContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    progressBar: {
        margin: theme.spacing(2)
    }
}));

const LowStockList = ({ showError }) => {

    const [materialMasters, setMaterialMasters] = useState([]);
    const [loading, setLoading] = useState(false);
    const classes = useStyles();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });

    const getLowStock = () => {
        setLoading(true);
        const response = api.get('get-low-stock');

        response.then(res => {
            setMaterialMasters(res);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(getLowStock, []);

    if (loading) {
        return <div className={classes.progressContainer}>
            <CircularProgress className={classes.progressBar} />
        </div>
    }
    return <MaterialTable
        isLoading={loading}
        columns={[
            { title: 'id', field: 'id', hidden: true },
            {
                hidden: isDesktop,
                render: rowData => <PPMobileCardView
                    title={rowData.materialName}
                    rows={[
                        { label: 'Min Stock', value: rowData.minimumStockValue },
                        { label: 'Current Stock', value: rowData.currentStock, bold: true },
                    ]}
                />,
                // Other columns are hidden on mobile, and material-table skips hidden columns when searching
                customFilterAndSearch: (term, rowData) => {
                    const values = [rowData.materialName, rowData.minimumStockValue, rowData.currentStock];
                    return values.some(value => value !== undefined && value !== null &&
                        String(value).toLowerCase().includes(term.toLowerCase()));
                },
            },
            { title: 'Name', field: 'materialName', editable: 'never', hidden: !isDesktop },
            { title: 'Min Stock', field: 'minimumStockValue', editable: 'never', defaultSort: 'desc', hidden: !isDesktop },
            { title: 'Current Stock', field: 'currentStock', editable: 'never', hidden: !isDesktop },
        ]}
        data={materialMasters}
        title='Stock Alert'
        options={{
            actionsColumnIndex: -1,
            search: true,
            showTitle: false,
            toolbar: true,
            header: isDesktop,
            pageSize:(materialMasters.length ? (materialMasters.length > 5 ? 5 : materialMasters.length ): 0),
            emptyRowsWhenPaging: false,
        }}
        
    />
};

export default LowStockList;